export default __webpack_public_path__ + "static/media/submitted-no-bg.b2d7ee82.svg";